<template>
  <div>
    <header-page :namePage="'Redis'" />
    <div class="content">
      <button
        class="btn btn_autowidth btn_blue redis-button"
        @click="updateMimks">
        {{ $t("admin.updateMimkList") }}
      </button>
      <button
        class="btn btn_autowidth btn_blue redis-button"
        @click="updateM1">
        {{ $t("admin.updateM1List") }}
      </button>
      <button
        class="btn btn_autowidth btn_blue redis-button"
        @click="updateSegments">
        {{ $t("admin.updateSegmentList") }}
      </button>
    </div>
  </div>
</template>

<script>
import apiAdmin from "@/api/admin";
export default {
  methods: {
    async updateMimks() {
      await apiAdmin.updateWorkedMimkList();
    },
    async updateM1() {
      await apiAdmin.updateWorkedM1List();
    },
    async updateSegments() {
      await apiAdmin.updateSegments();
    },
  },
};
</script>

<style lang="scss" scoped>
.redis-button {
  margin-bottom: 20px;
}
</style>
